import React, { useEffect, useState } from "react";
import { getUsersCount, getUsersCountV2, getUsersList, getUsersListV2 } from "../../../features/employees/helper/api";
import { isAuthenticated } from "../../../auth";
import { getUserRole } from "../../../lib/utils";
import _ from 'lodash'
// import config from "../../../config";
import client from "../../../clients";

const TrainerFilter = (props) => {
  
  const [currentElementId, setCurrentElementId] = useState("");
  const [isUserSpinnerLoader,setUserSpinnerLoader]=useState(false);
  const [usersList, setUsersList] = useState([]);
  var [pageNo,setPageNo] = useState(1);
  const [total,setTotal] = useState(0);
  const pageSize = 20;
  var [pageCount,setPageCount] = useState(0)
  const [userSearchKey,setUserSearchKey] = useState('');
  const [selectedTrainer, setSelectedTrainer] = useState(false);
  const {user,token} = isAuthenticated();
  
  const handleUserSearchKey = event =>{
    setUserSearchKey(event.target.value);
  }

  const toggleInputFields = (id) => {
    if (currentElementId == id) {
      setCurrentElementId('')
    } else {
      setCurrentElementId(id);
    }
  };

  const selectTrainer = (user) => {
    setSelectedTrainer(user)

    props.getRecipient(user)
  }



  const getUserParams = () => {
    let params = {
      pageNo,
      pageSize,
      isEmployee:true,
    };
    params.activationStatus = "activate";
    if (props.selectedGym) params.gymIDs = [props.selectedGym.gym[0]._id];
    if (props.selectedGym) params.branchIDs = props.selectedGym._id;
    if (userSearchKey) params.q = userSearchKey;
    return params;
  }

  const GetUsers = async (isReUpdateUsers) => {
    try {
      let params = getUserParams();
      let responses = await getUsersListV2(user._id, token, params);
      if(responses.error) return "";
      if(isReUpdateUsers) setUsersList(responses)
      else setUsersList([...usersList,...responses])
      setUsersList(responses)
    } catch (error) {
      console.error(error);
    }
  }

  const GetUserCount = async () => {
    try {
      let params = getUserParams();
      let attr = await getUsersCountV2(user._id, token, params);
      pageNo = 1;
      setPageNo(pageNo)
      total = attr.COUNT
      setTotal(total);
      pageCount = Math.ceil(attr.COUNT / pageSize)
      setPageCount(pageCount);

    } catch (error) {
      // do something
      console.error(error)
    }
  }


  const handleScroll = async event => {
    try{
      const { offsetHeight, scrollTop, scrollHeight } = event.target;

      if (offsetHeight + scrollTop === scrollHeight && pageNo < pageCount) {
        pageNo = pageNo + 1;
        setPageNo(pageNo)
        setUserSpinnerLoader(true)
        await GetUsers();
        setUserSpinnerLoader(false)
      }
    }catch(error){
      /// do something
      console.error(error)
    }
  }



  useEffect(async ()=>{
    try{
      setUserSpinnerLoader(true)
      await GetUsers(true);
      await GetUserCount()
      setUserSpinnerLoader(false)
    }catch(error){
      setUserSpinnerLoader(false)
    }
  },[userSearchKey]);


  useEffect(()=>{
    if(props.recipientUser){
      setSelectedTrainer(props.recipientUser);
    }
  },[props]);

  


  return(
    <div className="w-full">
      {
        props.headerView && (
          <p className="fs-16 m-t-8 m-b-6 font-weight-700 color-black">Filter by Trainer</p>
        )
      }
      <div onClick={()=>toggleInputFields('trainer-list')} className={`${currentElementId == "trainer-list" || selectedTrainer ? "member-global-input-field m-b-12 flex-item" : "member-global-input-field m-b-12 flex-item d-flex"}`} style={{ border: (currentElementId == "trainer-list" || selectedTrainer) ? "1px solid var(--darkBlue)" : "", height:"auto", minHeight:"54px" }}>
        <div className="flex-item d-flex" style={{marginTop: (currentElementId == "trainer-list" || selectedTrainer) ? "4px" : ""}}>
          <svg className="flex-item m-r-4" width={(currentElementId == "trainer-list" || selectedTrainer) ? "14" : "24"} height={(currentElementId == "trainer-list" || selectedTrainer) ? "14" : "24"} style={{ transition: "180ms" }} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M10.3154 8.22073C11.665 8.22073 12.7591 7.12665 12.7591 5.77704C12.7591 4.42742 11.665 3.33334 10.3154 3.33334C8.96578 3.33334 7.8717 4.42742 7.8717 5.77704C7.8717 7.12665 8.96578 8.22073 10.3154 8.22073Z" stroke={(currentElementId == "trainer-list" || selectedTrainer) ? "var(--darkBlue)" : "#6d6d6d"} stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M3.33337 16.25C3.33337 13.165 6.14676 10.6644 9.61716 10.6644M14.8536 12.759V11.7117C14.8536 11.434 14.7433 11.1676 14.5469 10.9712C14.3505 10.7748 14.0841 10.6644 13.8063 10.6644C13.5286 10.6644 13.2622 10.7748 13.0658 10.9712C12.8694 11.1676 12.759 11.434 12.759 11.7117V12.759M11.3627 12.759H16.25V16.25H11.3627V12.759Z" stroke={(currentElementId == "trainer-list" || selectedTrainer) ? "var(--darkBlue)" : "#6d6d6d"} stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
          <p className="placeholder-txt flex-item" style={{ fontSize: (currentElementId == "trainer-list" || selectedTrainer) ? "10px" : "16px", lineHeight: (currentElementId == "trainer-list" || selectedTrainer) ? "10px" : "14px", color: (currentElementId == "trainer-list" || selectedTrainer) ? "var(--darkBlue)" : "", transition: "180ms" }}>Trainer</p>
        </div>
        <div className='input-field-arrow-dropdown' style={{ margin: "15px 12px 4px 0", transition: "180ms" }}>
          <svg className="flex-item" style={{ transform: currentElementId == "trainer-list" ? "rotate(180deg)" : "", transition: "180ms" }} width="13" height="8" viewBox="0 0 13 8" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M1 1L6.5 6.5L12.5 1" stroke="var(--darkBlue)" stroke-linecap="round" />
          </svg>
        </div>
        {
          selectedTrainer ? (
            <div className="w-full d-flex m-t-8 m-b-8">
              {
                selectedTrainer.profileID ? (
                  <div className="pt-trainer-profile d-flex">
                    <img className="flex-item margin-auto" src={`${client.config.API_URL}/image/file/${selectedTrainer.profileID}/auto/auto/70`} />
                  </div>
                ) : (
                  <div className='pt-trainer-profile d-flex' style={{
                    backgroundColor: '#5d883c'
                  }}>
                    <p className='flex-item' style={{
                      color: '#ffffff',
                      fontSize: 14,
                      margin: '0 auto'
                    }}>
                      {`${selectedTrainer.name}`.trim()[0]}
                    </p>
                  </div>
                )
              }
              <div className="flex-item m-l-12">
                <p className="font-weight-600 fs-16" style={{lineHeight:"16px"}}>{selectedTrainer.name}</p>
                <p className="fs-12 m-t-6" style={{lineHeight:"12px"}}>{selectedTrainer.phone?selectedTrainer.phone:"----"}</p>
              </div>
            </div>
          ) : <input id="trainer-list"  className={`${(currentElementId == "trainer-list" || selectedTrainer) ? "active-input-field" : "inactive-input-field"}`} type="text" placeholder="Select Trainer" value={selectedTrainer ? selectedTrainer : ""} style={{ pointerEvents: "none", textTransform: 'capitalize' }} />
        }
        
        {/* <input id="trainer-list" className={`${(currentElementId == "trainer-list" || selectedTrainer) ? "active-input-field" : "inactive-input-field"}`} type="text" placeholder="Select PT Package" value={selectedTrainer ? selectedTrainer : ""} style={{ pointerEvents: "none", textTransform: 'capitalize' }} /> */}
        {
          currentElementId == "trainer-list" && (
            <div className="global-input-field-arrow-dropdown global-input-field-arrow-dropdown-height-1 scaleFromTopToBottom" style={{background:"#f5f5f5", border: "1px solid #f5f5f5"}}>
              <div onClick={e => e.stopPropagation()} className="w-full" style={{padding:"8px", backgroundColor:"#f5f5f5", position:"sticky", top:0}}>
                <div className="search-container d-flex space-between" style={{width:"100%",background:"#ffffff"}}>
                  <div className="d-flex w-full">
                    <svg className="flex-item m-r-6" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M21 21L16.657 16.657M16.657 16.657C17.3999 15.9141 17.9892 15.0322 18.3912 14.0615C18.7933 13.0909 19.0002 12.0506 19.0002 11C19.0002 9.9494 18.7933 8.90908 18.3913 7.93845C17.9892 6.96782 17.3999 6.08589 16.657 5.343C15.9141 4.60011 15.0322 4.01082 14.0616 3.60877C13.0909 3.20673 12.0506 2.99979 11 2.99979C9.94942 2.99979 8.90911 3.20673 7.93848 3.60877C6.96785 4.01082 6.08591 4.60011 5.34302 5.343C3.84269 6.84333 2.99982 8.87821 2.99982 11C2.99982 13.1218 3.84269 15.1567 5.34302 16.657C6.84335 18.1573 8.87824 19.0002 11 19.0002C13.1218 19.0002 15.1567 18.1573 16.657 16.657Z" stroke="#000000" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                    <input onChange={_.debounce(handleUserSearchKey,700)} type="text" placeholder={`Search Trainer by “Name“`} className="flex-item search-input" style={{width:"85%"}} />
                  </div>
                </div>
              </div>
              <div onScroll={handleScroll} className="w-full" style={{padding:"0px 8px 8px 8px",minHeight:300,maxHeight:400,overflowY:'auto'}}>
                {
                  usersList.map((trainer, index) => {
                    return (
                      <div onClick={()=>selectTrainer(trainer)} className="global-input-field-arrow-dropdown-item d-flex">
                       
                        {
                            trainer.profileID ? (
                              <div className="pt-trainer-profile d-flex">
                                <img className="flex-item margin-auto" src={`${client.config.API_URL}/image/file/${trainer.profileID}/auto/auto/70`} />
                              </div>
                            ) : (
                              <div className='pt-trainer-profile d-flex' style={{
                                backgroundColor:'#5d883c'
                              }}>
                                <p className='flex-item' style={{
                                  color: '#ffffff',
                                  fontSize: 14,
                                  margin: '0 auto'
                                }}>
                                  {`${trainer.name}`.trim()[0]}
                                </p>
                              </div>
                            )
                          }
                        <div className="flex-item m-l-12">
                          <p className="font-weight-600 fs-16" style={{lineHeight:"16px"}}>{trainer.name} <span style={{fontSize:12}}>({trainer.roleList.map(d=>client.config.roleNames[d.name]).join(',')})</span></p>
                          <p className="m-t-6" style={{lineHeight:"12px", fontSize:"12px", color:"#4d4d4d"}}>{trainer.phone?trainer.phone:"----"}</p>
                        </div>
                      </div>
                    )
                  })
                }
              {isUserSpinnerLoader && <div className="loader-5 center"><span></span></div>}
              </div>
            </div>
          )
        }
      </div>
    </div>
  )
}

export default TrainerFilter;